// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'

Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
});
Vue.config.productionTip = false;
import $ from 'jquery'
export var bus = new Vue()
new Vue({
  el: '#app',
  router,
  $,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js